import React, { useEffect } from 'react';
import ContactForm from '../components/sections/ContactForm';
import ContactInfo from '../components/sections/ContactInfo';
import Banner4 from '../components/sections/Banner4';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="bg-black min-h-screen pt-10">
      <ContactForm />
      <ContactInfo />
      <Banner4 />
    </main>
  );
};

export default Contact;
